import { GodotDocsVersion } from "./GodotDocsVersion";

export class GodotDocsFile
{
  name:string;
  icon:string;
  inheritance:string[];

  static create( name:string, icon:string, inheritance:string[] )
  {
    let gdf = new GodotDocsFile();
    
    gdf.name = name;
    gdf.icon = icon;
    gdf.inheritance = inheritance;

    return gdf;
  }

  static isRokojori( gdf:GodotDocsFile )
  {
    return gdf.icon.includes( "rokojori" );
  }

  static getLink( gdf:GodotDocsFile )
  {
    let version = GodotDocsVersion.newestVersion;

    let ralLink = `::/en/labs/godot/docs/${version}/rokojori/`;
    let docLink = `::/en/labs/godot/docs/${version}/godot/`;

    let link = GodotDocsFile.isRokojori( gdf ) ? ralLink : docLink;

    return link + gdf.name.toLowerCase() + "-class";
  }
}